import { createReducer } from '@reduxjs/toolkit'
import { toggleMenuDisplay } from './actions'

type MenuState = {
  isDisplay: boolean
}

export const menuReducer = createReducer<MenuState>(
  {
    isDisplay: true,
  },
  (builder) =>
    builder.addCase(toggleMenuDisplay, (state, { payload: { isDisplay } }) => {
      state.isDisplay = isDisplay
    }),
)
